// features/licenses/licenseSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchO365Licenses = createAsyncThunk(
  'O365/fetchO365Licenses',
  async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/o365/licenses`,
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
        },
      }
    );
    return res.data;
  }
);

export const fetchO365Users = createAsyncThunk(
  'O365/fetchO365Users',
  async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/o365/users`,
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
        },
      }
    );
    return res.data;
  }
);

const O365Slice = createSlice({
  name: 'O365',
  initialState: {
      licenses: {
        data: [],
        loading: false,
        error: null,
      },
      users: {
        data: [],
        loading: false,
        error: null,
      },
    },
  reducers: {},
   extraReducers: (builder) => {
    // FETCH LICENSES
    builder
      .addCase(fetchO365Licenses.pending, (state) => {
        state.licenses.loading = true;
      })
      .addCase(fetchO365Licenses.fulfilled, (state, action) => {
        state.licenses.loading = false;
        state.licenses.data = action.payload;
      })
      .addCase(fetchO365Licenses.rejected, (state, action) => {
        state.licenses.loading = false;
        state.licenses.error = action.error.message;
      });

    // FETCH USERS
    builder
      .addCase(fetchO365Users.pending, (state) => {
        state.users.loading = true;
      })
      .addCase(fetchO365Users.fulfilled, (state, action) => {
        state.users.loading = false;
        state.users.data = action.payload;
      })
      .addCase(fetchO365Users.rejected, (state, action) => {
        state.users.loading = false;
        state.users.error = action.error.message;
      });
  },
});

export default O365Slice.reducer;
